import styled from 'styled-components';

export const HistogramChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
